import img1 from '../Images/book_image1.jfif';
import img2 from '../Images/book_image2.jfif';
import img3 from '../Images/book_image3.jfif';
import img4 from '../Images/book_image4.jfif';
import img5 from '../Images/book_image5.jfif';
import img6 from '../Images/book_image6.jfif';
import img7 from '../Images/book_image7.jfif';
import img8 from '../Images/book_image8.jfif';
import img9 from '../Images/book_image9.jfif';


const BookData = {
    productData:[
        {
            id:10,
            img:img1,
            title:'Physical Science',
            desc:'Physical science is the study of the inorganic world. That is, it does not study living things, which include meteorology and geology',
            price:500,
        },
        {
            id:11,
            img:img2,
            title:'Oxford Dictionary',
            desc:'A dictionary is a reference book about words and as such it describes the functioning of individual words',
            price:200,
        },
        {
            id:12,
            img:img3,
            title:'Living Planet',
            desc:'In The Living Planet, based on his BBC television series, David Attenbouroughs searching eye good for nature lovers who wish to explore the world ',
            price:400,
        },
        {
            id:13,
            img:img4,
            title:'The Invention of Clouds ',
            desc:'The Invention of Clouds tells the extraordinary story of an amateur meteorologist, Luke Howard,and his groundbreaking work to define what had hitherto',
            price:250,
        },
        {
            id:14,
            img:img5,
            title:'Ace Of Shades',
            desc:'Ace of Shades is the story of Enne, a young nobody who goes in search of her adoptive mother in the City of Sin',
            price:299,
        },
        {
            id:15,
            img:img6,
            title:'The Lord Of The Lost',
            desc:'Lord of the Lost is a German gothic metal band from Hamburg. The band was formed by singer and frontman Chris Harms.',
            price:499,
        },
        {
            id:16,
            img:img7,
            title:'The White Tiger ',
            desc:'The Secret of His Success. Balram Halwai, the narrator of Aravind Adigas first novel. “The White Tiger,” is a modern Indian hero.',
            price:259,
        },
        {
            id:17,
            img:img8,
            title:'The DHONI Touch',
            desc:'Funny, candid, and peppered with delicious anecdotes, The Dhoni Touch reveals an ordinary man living an extraordinary life',
            price:500,
        },
        {
            id:18,
            img:img9,
            title:'Harry Potter',
            desc:'The novels chronicle the lives of a young wizard, Harry Potter, and his friends Hermione Granger and Ron Weasley',
            price:450,
        },
    ],
};

export default BookData;